(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avis-nolya-moto"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initNolyaReviews(root) {
    if (!root || root.dataset.nrReady === 'true') return;
    root.dataset.nrReady = 'true';

    const track = root.querySelector('[data-track]');
    const previous = root.querySelector('[data-prev]');
    const next = root.querySelector('[data-next]');
    const cards = Array.from(root.querySelectorAll('.nolya-review-card'));

    if (!track || cards.length < 1) return;

    const step = () => {
      const first = cards[0];
      if (!first) return track.clientWidth;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    };

    const move = (direction) => {
      track.scrollBy({ left: step() * direction, behavior: 'smooth' });
    };

    if (previous) previous.addEventListener('click', () => move(-1));
    if (next) next.addEventListener('click', () => move(1));

    const autoplay = root.dataset.autoplay === 'true';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let timer = null;

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function start() {
      if (!autoplay || reducedMotion || cards.length < 2 || document.hidden) return;
      stop();

      const delay = Math.max(4, Number(root.dataset.autoplaySpeed || 6)) * 1000;

      timer = window.setInterval(() => {
        const end = track.scrollWidth - track.clientWidth;
        if (track.scrollLeft >= end - 6) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          move(1);
        }
      }, delay);
    }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    root.addEventListener('touchstart', stop, { passive: true });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else start();
    });

    start();
  }

  function initAll(scope) {
    const base = scope || document;
    if (base.matches && base.matches('.nolya-reviews')) initNolyaReviews(base);
    if (base.querySelectorAll) {
      base.querySelectorAll('.nolya-reviews').forEach(initNolyaReviews);
    }
  }

  initAll(document);

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nolya-galerie-photos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nolya-gallery')) {
    class NolyaGallery extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.nolya-gallery__track');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.pauseOnHover = this.dataset.pauseHover === 'true';
        this.loop = this.dataset.loop === 'true';
        this.autoplaySpeed = Number(this.dataset.autoplaySpeed) || 5000;
        this.activeIndex = 0;
        this.maxIndex = this.slides.length - 1;
        this.scrollTimer = null;
        this.autoplayTimer = null;

        if (!this.track || this.slides.length < 1) return;

        this.onPrevious = () => this.goTo(this.activeIndex - 1);
        this.onNext = () => this.goTo(this.activeIndex + 1);
        this.onScroll = () => {
          window.clearTimeout(this.scrollTimer);
          this.scrollTimer = window.setTimeout(() => this.syncFromScroll(), 80);
        };
        this.onVisibilityChange = () => {
          if (document.hidden) this.stopAutoplay();
          else this.startAutoplay();
        };
        this.onPointerEnter = () => this.stopAutoplay();
        this.onPointerLeave = () => this.startAutoplay();
        this.onFocusIn = () => this.stopAutoplay();
        this.onFocusOut = () => this.startAutoplay();
        this.resizeObserver = new ResizeObserver(() => this.refreshLayout());

        this.previousButton?.addEventListener('click', this.onPrevious);
        this.nextButton?.addEventListener('click', this.onNext);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goTo(Number(dot.dataset.index)));
        });
        document.addEventListener('visibilitychange', this.onVisibilityChange);

        if (this.pauseOnHover) {
          this.addEventListener('pointerenter', this.onPointerEnter);
          this.addEventListener('pointerleave', this.onPointerLeave);
        }

        this.addEventListener('focusin', this.onFocusIn);
        this.addEventListener('focusout', this.onFocusOut);
        this.resizeObserver.observe(this.track);
        this.refreshLayout();
        this.startAutoplay();
      }

      disconnectedCallback() {
        window.clearTimeout(this.scrollTimer);
        this.stopAutoplay();
        this.resizeObserver?.disconnect();
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
      }

      refreshLayout() {
        const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const validIndexes = this.slides
          .map((slide, index) => ({ index, offset: slide.offsetLeft }))
          .filter((item) => item.offset <= maxScroll + 2);

        this.maxIndex = validIndexes.length ? validIndexes[validIndexes.length - 1].index : 0;
        this.dots.forEach((dot, index) => {
          dot.hidden = index > this.maxIndex;
        });

        const navigationHidden = this.maxIndex === 0;
        if (this.previousButton) this.previousButton.hidden = navigationHidden;
        if (this.nextButton) this.nextButton.hidden = navigationHidden;

        if (this.activeIndex > this.maxIndex) this.setActive(this.maxIndex);
      }

      syncFromScroll() {
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;

        this.slides.forEach((slide, index) => {
          if (index > this.maxIndex) return;
          const distance = Math.abs(this.track.scrollLeft - slide.offsetLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        this.setActive(closestIndex);
      }

      setActive(index) {
        this.activeIndex = index;
        this.dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === index;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      }

      goTo(index) {
        let targetIndex = index;

        if (targetIndex < 0) targetIndex = this.loop ? this.maxIndex : 0;
        if (targetIndex > this.maxIndex) targetIndex = this.loop ? 0 : this.maxIndex;

        const target = this.slides[targetIndex];
        if (!target) return;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: target.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
        this.setActive(targetIndex);
        this.restartAutoplay();
      }

      startAutoplay() {
        if (!this.autoplayEnabled || this.slides.length < 2 || document.hidden) return;
        this.stopAutoplay();
        this.autoplayTimer = window.setInterval(() => this.goTo(this.activeIndex + 1), this.autoplaySpeed);
      }

      stopAutoplay() {
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }

      restartAutoplay() {
        if (!this.autoplayEnabled) return;
        this.startAutoplay();
      }
    }

    customElements.define('nolya-gallery', NolyaGallery);
  }

  } catch(e) { console.error(e); }
})();
})();
